import React from "react";
import { useNavigate } from "react-router-dom";
import "./Closed.css";

import logo, { logoOnDark } from "../assets/logo.js";
import MailchimpSignup from "../components/MailchimpSignup";
import { useHomeVideo } from "../config/HomeVideos";
import { useNavDirection } from "../NavDirectionContext";

export default function Subscribe() {
  const navigate = useNavigate();
  const { setDir } = useNavDirection();

  // Même vidéo et même logique de couleur que la home. Depuis le 20/09/2026
  // cette page ne charge plus background.mp4 (11 Mo) : elle partage la vidéo
  // déjà tirée au sort pour l'accueil, donc déjà en cache, et sans piste audio.
  const { darkText } = useHomeVideo();

  const goHome = () => {
    setDir("down");
    navigate("/");
  };

  return (
    <div
      className={`closedPlain closedPlain--onVideo closedPlain--videoFull${
        darkText ? " closedPlain--darkText" : ""
      }`}
    >

      <div className="closedPlain__center">
        {/* ✅ logo cliquable => retour home avec anim DOWN */}
        <button
          className="closedVideo__logoBtn"
          onClick={goHome}
          aria-label="Back to home"
        >
          <img
            className="closedVideo__logo"
            src={darkText ? logo : logoOnDark}
            alt="Ghetto Symphony"
          />
        </button>

        <div className="closedVideo__formWrap">
          <MailchimpSignup cta="notify me" />
        </div>
      </div>
    </div>
  );
}
